<template lang="html">
  <v-dialog 
    v-model="dialog" 
    max-width="450"
  >
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <slot name="trigger" />
      </span>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      :title="name"
      color="green"
      text="Change Password"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row dense>
            <v-col
              v-if="oldPasswordRequired"
              cols="12"
            >
              <v-text-field
                v-model="oldPassword"
                v-validate="'required'"
                :error-messages="errors.collect('old_password')"
                data-vv-name="old_password"
                data-vv-as="old password"
                label="Current Password"
                type="password"
                counter            
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                ref="password"
                v-model="password"
                v-validate="'required'"
                :error-messages="errors.collect('password')"
                data-vv-name="password"
                data-vv-as="current password"
                label="New Password"
                type="password"
                counter            
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="confirmedPassword"
                v-validate="'required|confirmed:password'"
                :error-messages="errors.collect('confirmed_password')"
                data-vv-name="confirmed_password"
                data-vv-as="password"
                label="Re-type new password"
                type="password"
                counter
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="setDialog(false)"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"
          @click="submitForm"
        >
          Update Password
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      oldPasswordRequired: {
        type: Boolean,
        default: true,
      },
      user: {
        type: Object,
        default: function () {
          return {}
        },
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        oldPassword: '',
        password: '',
        confirmedPassword: '',
      }
    },
    computed: {
      name () {
        return (this.user || {}).name || ''
      },
    },
    watch: {
      dialog (status) {
        if (!status) {
          this.$validator.reset()
          this.$resetData()
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.users().update(this.user.user_uid, this.prepareFormData())
              .then((res) => {
                if (res.status >= 200 && res.status < 300) {              
                  this.$snack({
                    message: this.name + "'s password is updated successfully",
                  })

                  this.setDialog(false)
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
      prepareFormData () {
        let data = {
          password: this.password,
          ...(this.oldPasswordRequired && { old_password: this.oldPassword }),
        }

        return data
      },
    },
  }
</script>
